import { AuthContextProps } from '@screentone/addon-auth-wrapper';

function getUserId(user: AuthContextProps['user']): string {
  const unknownUserId = 'Unknown User';

  if (!user) return unknownUserId;

  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return user.sub ?? user.email ?? user.dj_user_id ?? unknownUserId;
}

export { getUserId };
